// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1RArf","header":"MessagesList_header__3AtMB","chat":"MessagesList_chat__3FbRa"};